import axios from 'axios';

const api = axios.create({
    baseURL: 'https://coffeebuy.cafemercado.com.br/api/'
});

export default api;
